import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HiX, HiGift, HiCake } from 'react-icons/hi';
import { supabase } from '../supabaseClient'; // Import Supabase client

const BirthdayToast = () => {
  const [birthdays, setBirthdays] = useState([]);
  const [showToast, setShowToast] = useState(false);

  // Helper function to check if someone has a birthday today
  const getTodaysBirthdays = (friendsList) => {
    const today = new Date();
    const month = today.getMonth() + 1;
    const date = today.getDate();
    
    return friendsList.filter(friend => {
      const birthdayDate = new Date(friend.birthday);
      return birthdayDate.getMonth() + 1 === month && birthdayDate.getDate() === date;
    });
  };

  useEffect(() => {
    const checkBirthdays = async () => {
      try {
        // Fetch birthdays from Supabase
        const { data, error } = await supabase
          .from('birthdays')
          .select('*')
          .order('name');
        
        if (error) {
          console.error('Error fetching birthdays:', error);
          return;
        }

        const todaysBirthdays = getTodaysBirthdays(data || []);
        if (todaysBirthdays.length > 0) {
          setBirthdays(todaysBirthdays);
          setShowToast(true);
          
          // Auto-hide after 10 seconds
          setTimeout(() => {
            setShowToast(false);
          }, 10000);
        }
      } catch (err) {
        console.error('Error:', err);
      }
    };

    // Check immediately
    checkBirthdays();

    // Check every hour
    const interval = setInterval(checkBirthdays, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  if (!showToast || birthdays.length === 0) return null;

  return (
    <AnimatePresence>
      {showToast && (
        <motion.div
          initial={{ opacity: 0, y: -100, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -100, scale: 0.8 }}
          transition={{ 
            type: "spring", 
            stiffness: 300, 
            damping: 30,
            duration: 0.5 
          }}
          className="fixed top-4 left-4 right-4 md:top-6 md:right-6 md:left-auto z-50 max-w-sm md:w-full w-auto mx-auto md:mx-0"
        >
                      <div className="glass-morphism-strong rounded-2xl p-4 md:p-6 shadow-2xl border border-accent-green/20">
                          <div className="flex items-start justify-between mb-3 md:mb-4">
                <div className="flex items-center space-x-2 md:space-x-3">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-gradient-to-br from-accent-green to-accent-blue rounded-full flex items-center justify-center">
                    <HiCake className="w-4 h-4 md:w-5 md:h-5 text-white" />
                  </div>
                  <div>
                    <h3 className="font-space-grotesk font-bold text-white text-base md:text-lg">
                      🎉 Birthday Alert!
                    </h3>
                    <p className="text-xs md:text-sm text-gray-300">
                      {birthdays.length === 1 ? 'Someone special has' : 'Some amazing people have'} a birthday today!
                    </p>
                  </div>
                </div>
                              <button
                  onClick={() => setShowToast(false)}
                  className="text-gray-400 hover:text-white transition-colors p-1 md:p-1 rounded-full hover:bg-white/10 flex-shrink-0"
                >
                  <HiX className="w-4 h-4 md:w-5 md:h-5" />
                </button>
            </div>

            <div className="space-y-2 md:space-y-3">
              {birthdays.map((birthday) => (
                <div
                  key={birthday.id}
                  className="flex items-center space-x-2 md:space-x-3 p-2 md:p-3 rounded-lg bg-white/5 border border-white/10"
                >
                  <div className="text-xl md:text-2xl">{birthday.avatar}</div>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-white text-sm md:text-base truncate">{birthday.name}</p>
                    <p className="text-xs md:text-sm text-gray-300">is celebrating today!</p>
                  </div>
                  <HiGift className="w-4 h-4 md:w-5 md:h-5 text-accent-green flex-shrink-0" />
                </div>
              ))}
            </div>

            <div className="mt-3 md:mt-4 pt-3 md:pt-4 border-t border-white/10">
              <button
                onClick={() => {
                  setShowToast(false);
                  window.location.href = '/birthdays';
                }}
                className="w-full bg-gradient-to-r from-accent-green to-accent-blue text-white font-medium py-2 md:py-2 px-3 md:px-4 rounded-lg hover:from-accent-green/90 hover:to-accent-blue/90 transition-all duration-200 transform hover:scale-105 text-sm md:text-base"
              >
                View Birthday Page
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BirthdayToast;